<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Jewel01 from './Jewel01.vue'
  import Jewel02 from './Jewel02.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Promo2020 from './Promo2020.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */


  /**
   * 過去弾の HR のアイテム情報群
   * @type {ItemInfo[]}
   */
  const externalHRs = _.where(
    [
      ...Jewel02.data().items,
      ...Jewel04.data().items,
      ...Jewel05.data().items,
    ],
    { rare: 'HR' }
  )

  /**
   * 過去弾のパシャッとアイテム情報群
   * @type {ItemInfo[]}
   */
  const externalPashaItems = _.where(
    [
      ...Jewel01.data().items,
      ...Jewel03.data().items,
    ],
    { kind: 'パシャッとアイテム' }
  )

  /**
   * 過去弾の HR のアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function externalHR (id = '', payload = {}) {
    return externalItem(externalHRs, id, payload)
  }

  /**
   * 過去弾のパシャッとアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function externalPashaItem (id = '', payload = {}) {
    return externalItem(externalPashaItems, id, payload)
  }

  /**
   * プロモ2020のアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function promo2020Item (id = '', payload = {}) {
    return externalItem(Promo2020.data().items, id, payload)
  }

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-05-04',
        major: [
          'PT03',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] WR
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-89',
            rare        : 'WR',
            name        : 'メルティックスターグループキラッツワンピ',
            imgUrl      : '/images/items/PT3-89.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH|DW',
            type        : 'LO',
            point       :  2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-90',
            rare        : 'WR',
            name        : 'メルティックスターグループキラッツシューズ',
            imgUrl      : '/images/items/PT3-90.png',
            kind        : 'シューズ',
            color       : '',
            brand       : 'SH|DW',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-91',
            rare        : 'WR',
            name        : 'メルティックスターグループキラッツヘアアクセ',
            imgUrl      : '/images/items/PT3-91.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : 'SH|DW',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'WR',
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-92',
            rare        : 'WR',
            name        : 'ミラクル☆キラッツグループメルティックワンピ',
            imgUrl      : '/images/items/PT3-92.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : 'DW|SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-93',
            rare        : 'WR',
            name        : 'ミラクル☆キラッツグループメルティックシューズ',
            imgUrl      : '/images/items/PT3-93.png',
            kind        : 'シューズ',
            color       : '',
            brand       : 'DW|SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-94',
            rare        : 'WR',
            name        : 'ミラクル☆キラッツグループメルティックヘアアクセ',
            imgUrl      : '/images/items/PT3-94.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW|SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'WR',
          }),


          // [NOTE] IR
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'IR03-01',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュまりあドレス',
            imgUrl      : '/images/items/IR03-01.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'IR03-02',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュまりあシューズ',
            imgUrl      : '/images/items/IR03-02.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'IR03-03',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュまりあヘアアクセ',
            imgUrl      : '/images/items/IR03-03.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT03',
            id          : 'IR03-04',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュすずドレス',
            imgUrl      : '/images/items/IR03-04.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'DS',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'IR03-05',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュすずシューズ',
            imgUrl      : '/images/items/IR03-05.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'IR03-06',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュすずヘアアクセ',
            imgUrl      : '/images/items/IR03-06.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT03',
            id          : 'IR03-07',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュポップドレス',
            imgUrl      : '/images/items/IR03-07.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'LP',
            type        : 'PO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'IR03-08',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュポップシューズ',
            imgUrl      : '/images/items/IR03-08.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'IR03-09',
            rare        : 'IR',
            name        : 'オーシャンマーメイドイルミナージュポップヘアアクセ',
            imgUrl      : '/images/items/IR03-09.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'IR',
          }),


          promo2020Item('IR03-10', {
            collection  : 'PT03',
            aggregation : '',
          }),
          item({
            collection  : 'PT03',
          }),
          item({
            collection  : 'PT03',
          }),
          item({
            collection  : 'PT03',
          }),


          // [NOTE] ER
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'ER3-01',
            rare        : 'ER',
            name        : 'クラシックドーリーワルツワンピ',
            imgUrl      : '/images/items/ER3-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-02',
            rare        : 'ER',
            name        : 'クラシックドーリーワルツシューズ',
            imgUrl      : '/images/items/ER3-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 4 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-03',
            rare        : 'ER',
            name        : 'クラシックドーリーワルツヘアアクセ',
            imgUrl      : '/images/items/ER3-03.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT03',
            id          : 'ER3-04',
            rare        : 'ER',
            name        : 'クラシックアイランジュワンピ',
            imgUrl      : '/images/items/ER3-04.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-05',
            rare        : 'ER',
            name        : 'クラシックアイランジュシューズ',
            imgUrl      : '/images/items/ER3-05.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-06',
            rare        : 'ER',
            name        : 'クラシックアイランジュヘアアクセ',
            imgUrl      : '/images/items/ER3-06.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT03',
            id          : 'ER3-07',
            rare        : 'ER',
            name        : 'キラッとチェックユニバースクイーンワンピ',
            imgUrl      : '/images/items/ER3-07.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-08',
            rare        : 'ER',
            name        : 'キラッとチェックユニバースクイーンシューズ',
            imgUrl      : '/images/items/ER3-08.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-09',
            rare        : 'ER',
            name        : 'キラッとチェックユニバースクイーンヘアアクセ',
            imgUrl      : '/images/items/ER3-09.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'ER',
          }),

          item({
            collection  : 'PT03',
            id          : 'ER3-10',
            rare        : 'ER',
            name        : 'キラッとチェックロマンスビートワンピ',
            imgUrl      : '/images/items/ER3-10.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-11',
            rare        : 'ER',
            name        : 'キラッとチェックロマンスビートシューズ',
            imgUrl      : '/images/items/ER3-11.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'ER3-12',
            rare        : 'ER',
            name        : 'キラッとチェックロマンスビートヘアアクセ',
            imgUrl      : '/images/items/ER3-12.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'ER',
          }),


          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-01',
            rare        : 'FR',
            name        : 'プリ☆ファンたんけんかトップス',
            imgUrl      : '/images/items/PT3-01.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1100,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-02',
            rare        : 'FR',
            name        : 'プリ☆ファンたんけんかパンツ',
            imgUrl      : '/images/items/PT3-02.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1050,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-03',
            rare        : 'FR',
            name        : 'プリ☆ファンたんけんかシューズ',
            imgUrl      : '/images/items/PT3-03.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-04',
            rare        : 'FR',
            name        : 'プリ☆ファンたんけんかヘアアクセ',
            imgUrl      : '/images/items/PT3-04.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-05',
            rare        : 'FR',
            name        : 'プリ☆ファンおどりこトップス',
            imgUrl      : '/images/items/PT3-05.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 1100,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-06',
            rare        : 'FR',
            name        : 'プリ☆ファンおどりこスカート',
            imgUrl      : '/images/items/PT3-06.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 1050,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-07',
            rare        : 'FR',
            name        : 'プリ☆ファンおどりこシューズ',
            imgUrl      : '/images/items/PT3-07.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-08',
            rare        : 'FR',
            name        : 'プリ☆ファンおどりこヘアアクセ',
            imgUrl      : '/images/items/PT3-08.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-09',
            rare        : 'PR',
            name        : 'ハピエストウエディングトップス',
            imgUrl      : '/images/items/PT3-09.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-10',
            rare        : 'PR',
            name        : 'ハピエストウエディングスカート',
            imgUrl      : '/images/items/PT3-10.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-11',
            rare        : 'PR',
            name        : 'ハピエストウエディングシューズ',
            imgUrl      : '/images/items/PT3-11.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-12',
            rare        : 'PR',
            name        : 'ハピエストウエディングヘアアクセ',
            imgUrl      : '/images/items/PT3-12.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-13',
            rare        : 'PR',
            name        : 'ピュアネスウエディングトップス',
            imgUrl      : '/images/items/PT3-13.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-14',
            rare        : 'PR',
            name        : 'ピュアネスウエディングパンツ',
            imgUrl      : '/images/items/PT3-14.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-15',
            rare        : 'PR',
            name        : 'ピュアネスウエディングシューズ',
            imgUrl      : '/images/items/PT3-15.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-16',
            rare        : 'PR',
            name        : 'ピュアネスウエディングヘアアクセ',
            imgUrl      : '/images/items/PT3-16.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-17',
            rare        : 'PR',
            name        : 'マスコットラビリィトップス',
            imgUrl      : '/images/items/PT3-17.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'LP',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-18',
            rare        : 'PR',
            name        : 'マスコットラビリィスカート',
            imgUrl      : '/images/items/PT3-18.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-19',
            rare        : 'PR',
            name        : 'マスコットラビリィシューズ',
            imgUrl      : '/images/items/PT3-19.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-20',
            rare        : 'PR',
            name        : 'マスコットラビリィヘアアクセ',
            imgUrl      : '/images/items/PT3-20.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-21',
            rare        : 'PR',
            name        : 'マジカる☆スカイトップス',
            imgUrl      : '/images/items/PT3-21.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       :  900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-22',
            rare        : 'PR',
            name        : 'マジカる☆スカイスカート',
            imgUrl      : '/images/items/PT3-22.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       :  800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-23',
            rare        : 'PR',
            name        : 'マジカる☆スカイシューズ',
            imgUrl      : '/images/items/PT3-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       :  850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-24',
            rare        : 'PR',
            name        : 'マジカる☆スカイヘアアクセ',
            imgUrl      : '/images/items/PT3-24.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       :  800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-25',
            rare        : 'SR',
            name        : 'もりのりすワンピ',
            imgUrl      : '/images/items/PT3-25.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-26',
            rare        : 'SR',
            name        : 'もりのりすシューズ',
            imgUrl      : '/images/items/PT3-26.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-27',
            rare        : 'SR',
            name        : 'もりのりすヘアアクセ',
            imgUrl      : '/images/items/PT3-27.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'SR',
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-28',
            rare        : 'SR',
            name        : 'ミルキーウェイすみれワンピ',
            imgUrl      : '/images/items/PT3-28.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-29',
            rare        : 'SR',
            name        : 'ミルキーウェイすみれシューズ',
            imgUrl      : '/images/items/PT3-29.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-30',
            rare        : 'SR',
            name        : 'ミルキーウェイすみれヘアアクセ',
            imgUrl      : '/images/items/PT3-30.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'SR',
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-31',
            rare        : 'SR',
            name        : 'きもだめしトップス',
            imgUrl      : '/images/items/PT3-31.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-32',
            rare        : 'SR',
            name        : 'きもだめしパンツ',
            imgUrl      : '/images/items/PT3-32.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-33',
            rare        : 'SR',
            name        : 'きもだめしシューズ',
            imgUrl      : '/images/items/PT3-33.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-34',
            rare        : 'SR',
            name        : 'きもだめしヘアアクセ',
            imgUrl      : '/images/items/PT3-34.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-35',
            rare        : 'SR',
            name        : 'ロッキンサマートップス',
            imgUrl      : '/images/items/PT3-35.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-36',
            rare        : 'SR',
            name        : 'ロッキンサマースカート',
            imgUrl      : '/images/items/PT3-36.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-37',
            rare        : 'SR',
            name        : 'ロッキンサマーシューズ',
            imgUrl      : '/images/items/PT3-37.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-38',
            rare        : 'SR',
            name        : 'ロッキンサマーヘアアクセ',
            imgUrl      : '/images/items/PT3-38.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-39',
            rare        : 'SR',
            name        : 'アイドルキャストポップトップス',
            imgUrl      : '/images/items/PT3-39.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'LP',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-40',
            rare        : 'SR',
            name        : 'アイドルキャストポップスカート',
            imgUrl      : '/images/items/PT3-40.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-41',
            rare        : 'SR',
            name        : 'アイドルキャストポップシューズ',
            imgUrl      : '/images/items/PT3-41.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-42',
            rare        : 'SR',
            name        : 'アイドルキャストポップヘアアクセ',
            imgUrl      : '/images/items/PT3-42.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-59',
            rare        : 'SR',
            name        : 'マスコットラビリィグリーントップス',
            imgUrl      : '/images/items/MF-59.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-60',
            rare        : 'SR',
            name        : 'マスコットラビリィグリーンスカート',
            imgUrl      : '/images/items/MF-60.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'LP',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-61',
            rare        : 'SR',
            name        : 'マスコットラビリィグリーンシューズ',
            imgUrl      : '/images/items/MF-61.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-62',
            rare        : 'SR',
            name        : 'マスコットラビリィグリーンヘアアクセ',
            imgUrl      : '/images/items/MF-62.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-44',
            rare        : 'R',
            name        : 'リトルリボンガーリートップス',
            imgUrl      : '/images/items/PT3-44.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-45',
            rare        : 'R',
            name        : 'リトルリボンガーリースカート',
            imgUrl      : '/images/items/PT3-45.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-46',
            rare        : 'R',
            name        : 'リトルリボンガーリーシューズ',
            imgUrl      : '/images/items/PT3-46.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-47',
            rare        : 'R',
            name        : 'リトルリボンガーリーヘアアクセ',
            imgUrl      : '/images/items/PT3-47.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-48',
            rare        : 'R',
            name        : 'ホワイトレーストップス',
            imgUrl      : '/images/items/PT3-48.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-49',
            rare        : 'R',
            name        : 'ホワイトレーススカート',
            imgUrl      : '/images/items/PT3-49.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-50',
            rare        : 'R',
            name        : 'ホワイトレースシューズ',
            imgUrl      : '/images/items/PT3-50.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-51',
            rare        : 'R',
            name        : 'ホワイトレースヘアアクセ',
            imgUrl      : '/images/items/PT3-51.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-52',
            rare        : 'R',
            name        : 'きんぎょゆかたトップス',
            imgUrl      : '/images/items/PT3-52.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-53',
            rare        : 'R',
            name        : 'きんぎょゆかたスカート',
            imgUrl      : '/images/items/PT3-53.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-54',
            rare        : 'R',
            name        : 'きんぎょゆかたシューズ',
            imgUrl      : '/images/items/PT3-54.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-55',
            rare        : 'R',
            name        : 'きんぎょゆかたヘアアクセ',
            imgUrl      : '/images/items/PT3-55.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-56',
            rare        : 'R',
            name        : 'プリティーオールフレンズゆいトップス',
            imgUrl      : '/images/items/PT3-56.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-57',
            rare        : 'R',
            name        : 'プリティーオールフレンズゆいスカート',
            imgUrl      : '/images/items/PT3-57.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-58',
            rare        : 'R',
            name        : 'プリティーオールフレンズゆいシューズ',
            imgUrl      : '/images/items/PT3-58.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-59',
            rare        : 'R',
            name        : 'プリティーオールフレンズゆいヘアアクセ',
            imgUrl      : '/images/items/PT3-59.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-60',
            rare        : 'R',
            name        : 'プリティーオールフレンズらぁらトップス',
            imgUrl      : '/images/items/PT3-60.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-61',
            rare        : 'R',
            name        : 'プリティーオールフレンズらぁらスカート',
            imgUrl      : '/images/items/PT3-61.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-62',
            rare        : 'R',
            name        : 'プリティーオールフレンズらぁらシューズ',
            imgUrl      : '/images/items/PT3-62.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-63',
            rare        : 'R',
            name        : 'プリティーオールフレンズらぁらヘアアクセ',
            imgUrl      : '/images/items/PT3-63.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-64',
            rare        : 'R',
            name        : 'パステルドリーミートップス',
            imgUrl      : '/images/items/PT3-64.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-65',
            rare        : 'R',
            name        : 'パステルドリーミーショートパンツ',
            imgUrl      : '/images/items/PT3-65.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-66',
            rare        : 'R',
            name        : 'パステルドリーミーシューズ',
            imgUrl      : '/images/items/PT3-66.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-67',
            rare        : 'R',
            name        : 'パステルドリーミーヘアアクセ',
            imgUrl      : '/images/items/PT3-67.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-68',
            rare        : 'R',
            name        : 'マスコットパーティーラブリートップス',
            imgUrl      : '/images/items/PT3-68.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'LP',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-69',
            rare        : 'R',
            name        : 'マスコットパーティーラブリースカート',
            imgUrl      : '/images/items/PT3-69.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'LP',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-70',
            rare        : 'R',
            name        : 'マスコットパーティーラブリーシューズ',
            imgUrl      : '/images/items/PT3-70.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-71',
            rare        : 'R',
            name        : 'マスコットパーティーラブリーヘアアクセ',
            imgUrl      : '/images/items/PT3-71.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-72',
            rare        : 'N',
            name        : 'ロッキンパイレーツカナリアトップス',
            imgUrl      : '/images/items/PT3-72.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-73',
            rare        : 'N',
            name        : 'ロッキンパイレーツカナリアスカート',
            imgUrl      : '/images/items/PT3-73.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-74',
            rare        : 'N',
            name        : 'ロッキンパイレーツカナリアシューズ',
            imgUrl      : '/images/items/PT3-74.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-75',
            rare        : 'N',
            name        : 'ロッキンパイレーツカナリアヘアアクセ',
            imgUrl      : '/images/items/PT3-75.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-76',
            rare        : 'N',
            name        : 'ガールズマーチブルートップス',
            imgUrl      : '/images/items/PT3-76.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-77',
            rare        : 'N',
            name        : 'ガールズマーチブルースカート',
            imgUrl      : '/images/items/PT3-77.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-78',
            rare        : 'N',
            name        : 'ガールズマーチブルーシューズ',
            imgUrl      : '/images/items/PT3-78.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-79',
            rare        : 'N',
            name        : 'ガールズマーチブルーヘアアクセ',
            imgUrl      : '/images/items/PT3-79.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-80',
            rare        : 'N',
            name        : 'マニッシュパンクネオントップス',
            imgUrl      : '/images/items/PT3-80.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-81',
            rare        : 'N',
            name        : 'マニッシュパンクネオンスカート',
            imgUrl      : '/images/items/PT3-81.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-82',
            rare        : 'N',
            name        : 'マニッシュパンクネオンシューズ',
            imgUrl      : '/images/items/PT3-82.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-83',
            rare        : 'N',
            name        : 'マニッシュパンクネオンヘアアクセ',
            imgUrl      : '/images/items/PT3-83.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-84',
            rare        : 'N',
            name        : 'パステルチューリップマゼンタワンピ',
            imgUrl      : '/images/items/PT3-84.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-85',
            rare        : 'N',
            name        : 'パステルチューリップマゼンタシューズ',
            imgUrl      : '/images/items/PT3-85.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-86',
            rare        : 'N',
            name        : 'パステルチューリップマゼンタヘアアクセ',
            imgUrl      : '/images/items/PT3-86.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'N',
          }),


          item({
            collection  : 'PT03',
            id          : 'PT3-87',
            rare        : 'N',
            name        : 'オトナガーリースカイブルーワンピ',
            imgUrl      : '/images/items/PT3-87.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            id          : 'PT3-88',
            rare        : 'N',
            name        : 'オトナガーリースカイブルーシューズ',
            imgUrl      : '/images/items/PT3-88.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'PS',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            rare        : 'N',
          }),
          item({
            collection  : 'PT03',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'PT03',
            id          : 'PT3-43',
            rare        : 'SR',
            name        : 'もりのことり',
            imgUrl      : '/images/items/PT3-43.png',
            kind        : 'パシャッとアイテム',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT03',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PT03',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PT03',
            kind        : 'パシャッとアイテム',
          }),



          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-84',
            rare        : 'SR',
            name        : 'モンスターくろねこワンピ',
            imgUrl      : '/images/items/PB-84.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-85',
            rare        : 'SR',
            name        : 'モンスターくろねこシューズ',
            imgUrl      : '/images/items/PB-85.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-86',
            rare        : 'SR',
            name        : 'モンスターくろねこヘアアクセ',
            imgUrl      : '/images/items/PB-86.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'SR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-87',
            rare        : 'SR',
            name        : 'マーブルラビットトップス',
            imgUrl      : '/images/items/PB-87.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-88',
            rare        : 'SR',
            name        : 'マーブルラビットスカート',
            imgUrl      : '/images/items/PB-88.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-89',
            rare        : 'SR',
            name        : 'マーブルラビットシューズ',
            imgUrl      : '/images/items/PB-89.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-90',
            rare        : 'SR',
            name        : 'マーブルラビットヘアアクセ',
            imgUrl      : '/images/items/PB-90.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          externalPashaItem('J1-98' , { collection: 'プレゼントボックス' }),
          externalPashaItem('J3-127', { collection: 'プレゼントボックス' }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-91-P',
            rare        : 'SR',
            name        : 'きんのひびきぞう',
            imgUrl      : '/images/items/PB-91-P.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] サンリオキャラクターズチャンネル
          // ================================================================================

          item({
            collection  : 'Sanrio',
            id          : 'PT3-101',
            rare        : 'SR',
            name        : 'ハローキティおでかけワンピ',
            imgUrl      : '/images/items/PT3-101.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT3-102',
            rare        : 'SR',
            name        : 'ハローキティおでかけシューズ',
            imgUrl      : '/images/items/PT3-102.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT3-103',
            rare        : 'SR',
            name        : 'ハローキティおでかけヘアアクセ',
            imgUrl      : '/images/items/PT3-103.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),


          item({
            collection  : 'Sanrio',
            id          : 'PT3-104',
            rare        : 'SR',
            name        : 'マイメロディ・クロミおでかけワンピ',
            imgUrl      : '/images/items/PT3-104.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT3-105',
            rare        : 'SR',
            name        : 'マイメロディ・クロミおでかけシューズ',
            imgUrl      : '/images/items/PT3-105.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT3-106',
            rare        : 'SR',
            name        : 'マイメロディ・クロミおでかけヘアアクセ',
            imgUrl      : '/images/items/PT3-106.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            rare        : 'SR',
          }),


          item({
            collection  : 'Sanrio',
            id          : 'PT3-107',
            rare        : 'SR',
            name        : 'マイメロディ・クロミパネル',
            imgUrl      : '/images/items/PT3-107.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'Sanrio',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'Sanrio',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ハッピーレア大量発生チャンネル
          // ================================================================================

          externalHR('J5-01', { collection: 'MassiveHR' }),
          externalHR('J5-02', { collection: 'MassiveHR' }),
          externalHR('J5-03', { collection: 'MassiveHR' }),
          externalHR('J5-04', { collection: 'MassiveHR' }),

          externalHR('J5-75', { collection: 'MassiveHR' }),
          externalHR('J5-76', { collection: 'MassiveHR' }),
          externalHR('J5-77', { collection: 'MassiveHR' }),
          externalHR('J5-78', { collection: 'MassiveHR' }),

          externalHR('J2-01', { collection: 'MassiveHR' }),
          externalHR('J2-02', { collection: 'MassiveHR' }),
          externalHR('J2-03', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J2-61', { collection: 'MassiveHR' }),
          externalHR('J2-62', { collection: 'MassiveHR' }),
          externalHR('J2-63', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J5-05', { collection: 'MassiveHR' }),
          externalHR('J5-06', { collection: 'MassiveHR' }),
          externalHR('J5-07', { collection: 'MassiveHR' }),
          externalHR('J5-08', { collection: 'MassiveHR' }),

          externalHR('J5-79', { collection: 'MassiveHR' }),
          externalHR('J5-80', { collection: 'MassiveHR' }),
          externalHR('J5-81', { collection: 'MassiveHR' }),
          externalHR('J5-82', { collection: 'MassiveHR' }),

          externalHR('J4-07', { collection: 'MassiveHR' }),
          externalHR('J4-08', { collection: 'MassiveHR' }),
          externalHR('J4-09', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J4-10', { collection: 'MassiveHR' }),
          externalHR('J4-11', { collection: 'MassiveHR' }),
          externalHR('J4-12', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J4-88', { collection: 'MassiveHR' }),
          externalHR('J4-89', { collection: 'MassiveHR' }),
          externalHR('J4-90', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalHR('J4-91', { collection: 'MassiveHR' }),
          externalHR('J4-92', { collection: 'MassiveHR' }),
          externalHR('J4-93', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),


          // [NOTE] ミルキーウェイチャンネル
          // ================================================================================

          item({
            collection  : 'MilkyWay',
            id          : 'PT3-95',
            rare        : 'SR',
            name        : 'ミルキーウェイももいろワンピ',
            imgUrl      : '/images/items/PT3-95.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MilkyWay',
            id          : 'PT3-96',
            rare        : 'SR',
            name        : 'ミルキーウェイももいろシューズ',
            imgUrl      : '/images/items/PT3-96.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MilkyWay',
            id          : 'PT3-97',
            rare        : 'SR',
            name        : 'ミルキーウェイももいろヘアアクセ',
            imgUrl      : '/images/items/PT3-97.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MilkyWay',
            rare        : 'SR',
          }),


          item({
            collection  : 'MilkyWay',
            id          : 'PT3-98',
            rare        : 'SR',
            name        : 'ミルキーウェイそらいろワンピ',
            imgUrl      : '/images/items/PT3-98.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MilkyWay',
            id          : 'PT3-99',
            rare        : 'SR',
            name        : 'ミルキーウェイそらいろシューズ',
            imgUrl      : '/images/items/PT3-99.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MilkyWay',
            id          : 'PT3-100',
            rare        : 'SR',
            name        : 'ミルキーウェイそらいろヘアアクセ',
            imgUrl      : '/images/items/PT3-100.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MilkyWay',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-01',
            rare        : 'PR',
            name        : 'ハピエストウエディングパープルトップス',
            imgUrl      : '/images/items/NC-PT3-01.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-02',
            rare        : 'PR',
            name        : 'ハピエストウエディングパープルスカート',
            imgUrl      : '/images/items/NC-PT3-02.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-PT3-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-03',
            rare        : 'PR',
            name        : 'ハピエストウエディングパープルシューズ',
            imgUrl      : '/images/items/NC-PT3-03.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-PT3-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-04',
            rare        : 'PR',
            name        : 'ハピエストウエディングパープルヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-04.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-PT3-01',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-05',
            rare        : 'PR',
            name        : 'マジカる☆フラワートップス',
            imgUrl      : '/images/items/NC-PT3-05.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-06',
            rare        : 'PR',
            name        : 'マジカる☆フラワースカート',
            imgUrl      : '/images/items/NC-PT3-06.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-PT3-05',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-07',
            rare        : 'PR',
            name        : 'マジカる☆フラワーシューズ',
            imgUrl      : '/images/items/NC-PT3-07.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PS',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-PT3-05',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-08',
            rare        : 'PR',
            name        : 'マジカる☆フラワーヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-08.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-PT3-05',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-09',
            rare        : 'SR',
            name        : 'ロッキンサマーブラッキートップス',
            imgUrl      : '/images/items/NC-PT3-09.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-10',
            rare        : 'SR',
            name        : 'ロッキンサマーブラッキースカート',
            imgUrl      : '/images/items/NC-PT3-10.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT3-09',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-11',
            rare        : 'SR',
            name        : 'ロッキンサマーブラッキーシューズ',
            imgUrl      : '/images/items/NC-PT3-11.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT3-09',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-12',
            rare        : 'SR',
            name        : 'ロッキンサマーブラッキーヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-12.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT3-09',


          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-13',
            rare        : 'SR',
            name        : 'もりのりすあかねいろワンピ',
            imgUrl      : '/images/items/NC-PT3-13.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-14',
            rare        : 'SR',
            name        : 'もりのりすあかねいろシューズ',
            imgUrl      : '/images/items/NC-PT3-14.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT3-13',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-15',
            rare        : 'SR',
            name        : 'もりのりすあかねいろヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-15.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT3-13',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-16',
            rare        : 'SR',
            name        : 'きもだめしピンクトップス',
            imgUrl      : '/images/items/NC-PT3-16.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-17',
            rare        : 'SR',
            name        : 'きもだめしピンクパンツ',
            imgUrl      : '/images/items/NC-PT3-17.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT3-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-18',
            rare        : 'SR',
            name        : 'きもだめしピンクシューズ',
            imgUrl      : '/images/items/NC-PT3-18.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT3-16',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-19',
            rare        : 'SR',
            name        : 'きもだめしピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-19.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT3-16',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-20',
            rare        : 'SR',
            name        : 'もこもこスノーアナザートップス',
            imgUrl      : '/images/items/NC-PT3-20.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-21',
            rare        : 'SR',
            name        : 'もこもこスノーアナザースカート',
            imgUrl      : '/images/items/NC-PT3-21.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            aggregation : 'NC-PT3-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-22',
            rare        : 'SR',
            name        : 'もこもこスノーアナザーシューズ',
            imgUrl      : '/images/items/NC-PT3-22.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT3-20',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-23',
            rare        : 'SR',
            name        : 'もこもこスノーアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-23.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'MR',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT3-20',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-24',
            rare        : 'R',
            name        : 'ティーンカジュアルトップス',
            imgUrl      : '/images/items/NC-PT3-24.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-25',
            rare        : 'R',
            name        : 'ティーンカジュアルスカート',
            imgUrl      : '/images/items/NC-PT3-25.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT3-24',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-26',
            rare        : 'R',
            name        : 'ティーンカジュアルシューズ',
            imgUrl      : '/images/items/NC-PT3-26.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-24',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-27',
            rare        : 'R',
            name        : 'ティーンカジュアルヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-27.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-24',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-28',
            rare        : 'R',
            name        : 'マスコットパーティークールトップス',
            imgUrl      : '/images/items/NC-PT3-28.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'LP',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-29',
            rare        : 'R',
            name        : 'マスコットパーティークールスカート',
            imgUrl      : '/images/items/NC-PT3-29.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT3-28',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-30',
            rare        : 'R',
            name        : 'マスコットパーティークールシューズ',
            imgUrl      : '/images/items/NC-PT3-30.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-28',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-31',
            rare        : 'R',
            name        : 'マスコットパーティークールヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-31.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-28',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-32',
            rare        : 'R',
            name        : 'マスコットパーティーポップトップス',
            imgUrl      : '/images/items/NC-PT3-32.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'LP',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-33',
            rare        : 'R',
            name        : 'マスコットパーティーポップスカート',
            imgUrl      : '/images/items/NC-PT3-33.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-PT3-32',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-34',
            rare        : 'R',
            name        : 'マスコットパーティーポップシューズ',
            imgUrl      : '/images/items/NC-PT3-34.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'LP',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT3-32',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-35',
            rare        : 'R',
            name        : 'マスコットパーティーポップヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-35.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-PT3-32',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-36',
            rare        : 'R',
            name        : 'マドモアゼルビターチョコワンピ',
            imgUrl      : '/images/items/NC-PT3-36.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-37',
            rare        : 'R',
            name        : 'マドモアゼルビターチョコシューズ',
            imgUrl      : '/images/items/NC-PT3-37.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-36',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-38',
            rare        : 'R',
            name        : 'マドモアゼルビターチョコヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-38.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-36',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-39',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストゴールドトップス',
            imgUrl      : '/images/items/NC-PT3-39.png',
            kind        : 'トップス',
            color       : '金',
            brand       : 'LP',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-40',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストゴールドスカート',
            imgUrl      : '/images/items/NC-PT3-40.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : 'LP',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT3-39',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-41',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストゴールドシューズ',
            imgUrl      : '/images/items/NC-PT3-41.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-39',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-42',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストゴールドヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-42.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-39',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-43',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブラックトップス',
            imgUrl      : '/images/items/NC-PT3-43.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-44',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブラックスカート',
            imgUrl      : '/images/items/NC-PT3-44.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT3-43',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-45',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブラックシューズ',
            imgUrl      : '/images/items/NC-PT3-45.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-43',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-46',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストブラックヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-46.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-43',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-47',
            rare        : 'R',
            name        : 'フローラルファーライラックトップス',
            imgUrl      : '/images/items/NC-PT3-47.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-48',
            rare        : 'R',
            name        : 'フローラルファーライラックスカート',
            imgUrl      : '/images/items/NC-PT3-48.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-PT3-47',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-49',
            rare        : 'R',
            name        : 'フローラルファーライラックシューズ',
            imgUrl      : '/images/items/NC-PT3-49.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT3-47',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-50',
            rare        : 'R',
            name        : 'フローラルファーライラックヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-50.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT3-47',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-51',
            rare        : 'R',
            name        : 'フローラルファーヒヤシンストップス',
            imgUrl      : '/images/items/NC-PT3-51.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-52',
            rare        : 'R',
            name        : 'フローラルファーヒヤシンススカート',
            imgUrl      : '/images/items/NC-PT3-52.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-PT3-51',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-53',
            rare        : 'R',
            name        : 'フローラルファーヒヤシンスシューズ',
            imgUrl      : '/images/items/NC-PT3-53.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT3-51',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-54',
            rare        : 'R',
            name        : 'フローラルファーヒヤシンスヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-54.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-PT3-51',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-55',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクレッドトップス',
            imgUrl      : '/images/items/NC-PT3-55.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-56',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクレッドスカート',
            imgUrl      : '/images/items/NC-PT3-56.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT3-55',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-57',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクレッドシューズ',
            imgUrl      : '/images/items/NC-PT3-57.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-55',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-58',
            rare        : 'R',
            name        : 'ティーカップメルヘンリメイクレッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-58.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-55',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-59',
            rare        : 'R',
            name        : 'きんぎょゆかたよぞらトップス',
            imgUrl      : '/images/items/NC-PT3-59.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-60',
            rare        : 'R',
            name        : 'きんぎょゆかたよぞらスカート',
            imgUrl      : '/images/items/NC-PT3-60.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT3-59',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-61',
            rare        : 'R',
            name        : 'きんぎょゆかたよぞらシューズ',
            imgUrl      : '/images/items/NC-PT3-61.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-59',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-62',
            rare        : 'R',
            name        : 'きんぎょゆかたよぞらヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-62.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT3-59',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-63',
            rare        : 'R',
            name        : 'ハッピースウィムマカロンワンピ',
            imgUrl      : '/images/items/NC-PT3-63.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-64',
            rare        : 'R',
            name        : 'ハッピースウィムマカロンシューズ',
            imgUrl      : '/images/items/NC-PT3-64.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-63',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-65',
            rare        : 'R',
            name        : 'ハッピースウィムマカロンヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-65.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-63',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-66',
            rare        : 'R',
            name        : 'はなやかゆかたそらいろトップス',
            imgUrl      : '/images/items/NC-PT3-66.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-67',
            rare        : 'R',
            name        : 'はなやかゆかたそらいろスカート',
            imgUrl      : '/images/items/NC-PT3-67.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT3-66',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-68',
            rare        : 'R',
            name        : 'はなやかゆかたそらいろシューズ',
            imgUrl      : '/images/items/NC-PT3-68.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-66',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-69',
            rare        : 'R',
            name        : 'はなやかゆかたそらいろアクセサリー',
            imgUrl      : '/images/items/NC-PT3-69.png',
            kind        : '',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-66',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-70',
            rare        : 'R',
            name        : 'リトルリボンガーリーレッドトップス',
            imgUrl      : '/images/items/NC-PT3-70.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-71',
            rare        : 'R',
            name        : 'リトルリボンガーリーレッドスカート',
            imgUrl      : '/images/items/NC-PT3-71.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT3-70',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-72',
            rare        : 'R',
            name        : 'リトルリボンガーリーレッドシューズ',
            imgUrl      : '/images/items/NC-PT3-72.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-70',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-73',
            rare        : 'R',
            name        : 'リトルリボンガーリーレッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-73.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-70',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-74',
            rare        : 'R',
            name        : 'リトルリボンガーリーブルートップス',
            imgUrl      : '/images/items/NC-PT3-74.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-75',
            rare        : 'R',
            name        : 'リトルリボンガーリーブルースカート',
            imgUrl      : '/images/items/NC-PT3-75.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT3-74',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-76',
            rare        : 'R',
            name        : 'リトルリボンガーリーブルーシューズ',
            imgUrl      : '/images/items/NC-PT3-76.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-74',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT3-77',
            rare        : 'R',
            name        : 'リトルリボンガーリーブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT3-77.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT3-74',
          }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsHR () {
        return _.where(this.itemsFiltered, { rare: 'HR' })
      },

      itemsIR () {
        return _.where(this.itemsMaJor, { rare: 'IR' })
      },

      itemsWR () {
        return _.where(this.itemsMaJor, { rare: 'WR' })
      },

      itemsER () {
        return _.where(this.itemsMaJor, { rare: 'ER' })
      },

      itemsFR () {
        return _.where(this.itemsMaJor, { rare: 'FR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsSanrio () {
        return _.where(this.itemsFiltered, { collection: 'Sanrio' })
      },

      itemsMilkyWay () {
        return _.where(this.itemsFiltered, { collection: 'MilkyWay' })
      },

      items__TBD2__ () {
        return _.where(this.itemsFiltered, { collection: '__TBD2__' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
    </template>

    <template #col2>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col5>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>

    <template #col6>
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="ミルキーウェイチャンネル" color="#a1c0fa" :items="itemsMilkyWay" />
      <ItemList title="サンリオキャラクターズチャンネル" color="#a1c0fa" :items="itemsSanrio" />
    </template>

    <template #col7>
      <ItemList title="ハッピーレア大量発生チャンネル" color="#ff5d91" :items="itemsHR" />
    </template>

    <template #col8>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col9>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(7 * 4)" />
    </template>

    <template #col10>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(7 * 4)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 222;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 10;
  //   }
  // }
</style>
